<template>
    <a :href="href" target="_blank">
      {{ title }}
      <icon class="mb-1" name="external-link-alt" scale="0.8"/>
    </a>
</template>

<script>
  import 'vue-awesome/icons/external-link-alt'

  export default {
    props: {
      href: {
        type: String,
        required: true
      },
      title: {
        type: String,
        required: true
      }
    }
  }
</script>
